
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise'
import { Subject } from 'rxjs/Subject'
import { Storage } from '@ionic/storage';


//Providers
import { ConfigProvider } from '../providers/config-provider';
import { UtilProvider } from '../providers/util-provider';

import { Url } from '../models/url.model';
import { Banner } from '../models/banner.model';

@Injectable()
export class StorageProvider {

    constructor(private storage: Storage) { }

    set(key: string, data: any) {
        if (key == 'usuario') {
            var nomeSplited = data.Nome.split(' ');

            data.NomeReduzido = nomeSplited[0];

            if (nomeSplited.length > 1)
                data.NomeReduzido += ' ' + nomeSplited[nomeSplited.length - 1];
        }

        localStorage.setItem(key, JSON.stringify(data));
    }

    get(key: string) {
        return JSON.parse(localStorage.getItem(key));
    }

    clear(key: string) {
        if (key == undefined || key == '' || key == null)
            localStorage.clear();
        else
            localStorage.removeItem(key);
    }

    insert(key: string, data: any) {
        if (key == 'usuario') {
            var nomeSplited = data.Nome.split(' ');

            data.NomeReduzido = nomeSplited[0];

            if (nomeSplited.length > 1)
                data.NomeReduzido += ' ' + nomeSplited[nomeSplited.length - 1];
        }

        this.storage.set(key, JSON.stringify(data));
    }

    getting(key: string) {
        return this.storage.get(key).then((val) => {
            return JSON.parse(val);
        });
    }

}


// WEBPACK FOOTER //
// ./src/providers/storage-provider.ts